import React from 'react';
import { Link } from 'react-router-dom'; // Or use a simple 'a' tag if linking to external/anchor

interface BrandLogoProps {
  href?: string; // Optional: if the logo should be a link
  imgSrc?: string;
  imgAlt?: string;
  text?: string;
  imgSizeClass?: string;
  textSizeClass?: string;
  textGradientClasses?: string;
  containerClass?: string;
  onClick?: () => void; // For handling clicks if not a direct link
}

const BrandLogo: React.FC<BrandLogoProps> = ({
  href = "/", // Default link to homepage
  imgSrc = "/logo.png", // Default image source from public folder
  imgAlt = "ScanMaadi Logo",
  text = "ScanMaadi",
  imgSizeClass = "h-10 w-10", // Default image size
  textSizeClass = "text-3xl", // Default text size
  textGradientClasses = "text-transparent bg-clip-text bg-gradient-to-r from-primary-500 to-highlight-400",
  containerClass = "flex items-center",
  onClick,
}) => {
  const logoContent = (
    <>
      <img src={imgSrc} alt={imgAlt} className={`${imgSizeClass} mr-2 sm:mr-3`} />
      <span className={`${textSizeClass} font-extrabold ${textGradientClasses} relative`}>
        {text}
      </span>
    </>
  );

  if (onClick) {
    return (
      <button onClick={onClick} className={`${containerClass} focus:outline-none`}>
        {logoContent}
      </button>
    );
  }

  if (href) {
    if (href.startsWith('#') || href.startsWith('/')) {
      // Internal link or anchor
      return (
        <Link to={href} className={containerClass}>
          {logoContent}
        </Link>
      );
    }
    // External link
    return (
      <a href={href} className={containerClass} target="_blank" rel="noopener noreferrer">
        {logoContent}
      </a>
    );
  }

  // Not a link, just display
  return <div className={containerClass}>{logoContent}</div>;
};

export default BrandLogo;